import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { resetFrom, nextStep, updateSurvey, checkLastStep } from 'store/actions';
import { OPTIONS } from 'constants/survey';
import { handleResult } from 'shared/decision';

import StepperNav from 'components/StepperNav/StepperNav';
import SelectionCard from 'components/SelectionCard/SelectionCard';

import yesImg from 'assets/images/options/check.png';
import noImg from 'assets/images/options/cross.png';
import donnoImg from 'assets/images/options/qtag.png';

import Analytics from '../../utils/analytics';

const mapStateToProps = (state) => ({
  isLastStep: state.isLastStep,
  survey: state.survey
});

const mapDispatchToProps = (dispatch) => ({
  resetFrom: (prop) => dispatch(resetFrom(prop)),
  nextStep: () => dispatch(nextStep()),
  updateSurvey: (survey) => dispatch(updateSurvey(survey)),
  checkLastStep: () => dispatch(checkLastStep())
});

class Step5 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: ''
    };
  }

  componentDidUpdate() {
    const { survey, isLastStep } = this.props;

    if (isLastStep) {
      handleResult(survey);
    }
  }

  handleSelection = (selectedOption) => {
    const { survey, resetFrom, updateSurvey, nextStep, checkLastStep } = this.props;

    if (selectedOption) {
      this.setState({value: selectedOption})
    }

    if (!survey.bill.length) {
      // Update data from the last step
      const updatedSurvey = {
        ...survey,
        ...{bill: selectedOption},
      };

      updateSurvey(updatedSurvey);
    } else if (survey.bill !== selectedOption) {
      resetFrom({bill: selectedOption});
    }

    const filteredType = Analytics.removeAccentMarkAndUppercase(selectedOption);

    Analytics.pushData({
      eventCategory: 'recomendador starressa',
      eventAction: 'clic boton',
      eventLabel: `step5_factura_${filteredType}`
    });

    checkLastStep();

    nextStep();
  }

  render() {
    const { t, survey } = this.props;

    const optionsTypes = [
      {name: t(OPTIONS.YES), imgSrc: yesImg, value: t(OPTIONS.YES)},
      {name: t(OPTIONS.NO), imgSrc: noImg, value: t(OPTIONS.NO)},
      {name: t(OPTIONS.DONNO), imgSrc: donnoImg, value: t(OPTIONS.DONNO)}
    ]

    return (
      <section className="m-step">
        <div className="m-step__header">
          <h2 className="t-h2 m-step__title">{t('steps.step5.title')}</h2>
        </div>
        <div className="m-step m-step__content m-step5">
            {
              optionsTypes.map((type, index) => {
                return (
                  <SelectionCard
                    extraClass={"m-step__card m-step__card--third" + (survey.bill && optionsTypes[index].value === survey.bill ? ' is-active' : '')}
                    key={index}
                    onClick={() => this.handleSelection(optionsTypes[index].value)}
                    label={optionsTypes[index].name}
                    imgSrc={optionsTypes[index].imgSrc} />
                );
              })
            }
        </div>
        <StepperNav
          hideNextBtn={true} />
      </section>
    );
  }
}

const ConnectedStep5 = connect(mapStateToProps, mapDispatchToProps)(Step5);
export default withTranslation('translations')(ConnectedStep5);
